/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_Cli_DocsInputs */

const en_mk_foot_cli_docs = /** @type {(inputs: Mk_Foot_Cli_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI reference`)
};

const id_mk_foot_cli_docs = /** @type {(inputs: Mk_Foot_Cli_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referensi CLI`)
};

/**
* | output |
* | --- |
* | "CLI reference" |
*
* @param {Mk_Foot_Cli_DocsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_cli_docs = /** @type {((inputs?: Mk_Foot_Cli_DocsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_Cli_DocsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_cli_docs(inputs)
	return en_mk_foot_cli_docs(inputs)
});